(function () {
  if (window.__bwxPdp) return; window.__bwxPdp = true;
  var STORE = 'bouncewear.com';
  var cache = {};
  function getJSON(url) { if (!cache[url]) cache[url] = fetch(url).then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; }); return cache[url]; }
  function dec(s) { var t = document.createElement('textarea'); t.innerHTML = String(s || ''); t.innerHTML = t.value; return t.value.replace(/^"+|"+$/g, '').trim(); }
  function fmt(n) { var l = (document.documentElement.lang || 'en').slice(0, 2); return Number(n).toLocaleString(l === 'en' ? 'en-GB' : l, { minimumFractionDigits: 1, maximumFractionDigits: 1 }); }
  function esc(s) { var d = document.createElement('div'); d.textContent = s; return d.innerHTML; }
  function productReviews(skus, page) {
    return getJSON('https://api.reviews.io/product/review?store=' + STORE + '&sku=' + encodeURIComponent(skus) + '&per_page=3&page=' + (page || 1));
  }

  /* stock lines above the add to cart button: online + store, per selected size */
  /* size labels like "7.5 (EU38.5)": EU / US toggle */
  var SZ_RE = /^\s*([^()]+?)\s*\(\s*EU\s*([^)]+)\)\s*$/i;
  var szMode = 'eu';
  try { szMode = localStorage.getItem('bwxSz') || 'eu'; } catch (e) {}
  var UK = null; /* label US size -> { uk, men }, from the theme's sizes.json (nike.unisex: women's US -> men's US / UK / EU) */
  function nz(v) { return String(v == null ? '' : v).replace(',', '.').replace(/\s+/g, '').toLowerCase(); }
  function szText(raw, full) {
    var m = SZ_RE.exec(String(raw || '')); if (!m) return String(raw || '');
    var us = m[1].trim(), x = UK && UK[us];
    if (szMode === 'uk' && x && x.uk) return 'UK ' + x.uk;
    if (szMode === 'us') {
      if (x && x.men && x.men !== us) return 'US ' + x.men + (full ? ' (W ' + us + ')' : '');
      return 'US ' + us;
    }
    return 'EU ' + m[2].trim();
  }
  function loadUK(f, pairs, done) {
    var v = document.querySelector('.o-product__information .js-variants');
    var brand = v && v.getAttribute('data-brand');
    if (!brand || !window.sizesUrlJSON) return;
    getJSON((String(window.sizesUrlJSON).indexOf('//') === 0 ? 'https:' : '') + window.sizesUrlJSON).then(function (d) {
      var b = d && d.sizes && d.sizes[brand]; if (!b) return;
      function score(g) { var n = 0; pairs.forEach(function (p) { var e = b[g] && b[g][p[0]]; if (e && nz(e.eu) === nz(p[1]) && e.uk != null) n++; }); return n; }
      var best = null, bestN = 0;
      var order = Object.keys(b).sort(function (a, c) { return (c === 'unisex') - (a === 'unisex'); });
      order.forEach(function (g) { var n = score(g); if (n > bestN) { bestN = n; best = g; } });
      if (!best || bestN < pairs.length * 0.6) return;
      UK = {};
      pairs.forEach(function (p) { var e = b[best][p[0]]; if (e && e.uk != null) UK[p[0]] = { uk: String(e.uk), men: e.men != null ? String(e.men) : '' }; });
      done();
    });
  }
  /* active system of the theme's own EU / US / UK toggle (products with a gender tag) */
  function themeSys(f) {
    var w = f.querySelector('.js-toggles-wrapper'); if (!w) return '';
    var bs = [].slice.call(w.querySelectorAll('button')); if (!bs.length) return '';
    var on = bs.filter(function (x) { return x.getAttribute('data-bwx-act') === '1'; })[0];
    if (!on) {
      on = bs.filter(function (x) { return /(^|[\s_-])(is-)?(active|selected|current)/i.test(x.className) || x.getAttribute('aria-pressed') === 'true'; })[0]
        || bs.filter(function (x) { return x.textContent.trim().toLowerCase() === 'eu'; })[0] || bs[0];
      on.setAttribute('data-bwx-act', '1');
    }
    bs.forEach(function (x) { x.classList.toggle('bwx-on', x === on); });
    return on.textContent.trim().toUpperCase();
  }
  var ukTried = false;
  function sizes() {
    function fs() { return document.querySelector('.o-product__information .m-variants__fieldset[data-variant-type="size"]'); }
    function paint() {
      var f = fs(); if (!f) return;
      var spans = [].slice.call(f.querySelectorAll('.js-variant[data-size]'));
      var ok = spans.filter(function (x) { return SZ_RE.test(x.getAttribute('data-size')); }).length;
      var can = spans.length && ok / spans.length > 0.6;
      if (can) {
        if (szMode === 'uk' && !UK) szMode = 'eu';
        spans.forEach(function (x) { var v = szText(x.getAttribute('data-size')).replace(new RegExp('^' + szMode.toUpperCase() + ' '), '').replace(/^EU /, 'EU'); if (x.textContent !== v) x.textContent = v; });
        if (!f.querySelector('.bwx-tog')) {
          var bar = f.querySelector('.m-variants__toolbar') || f;
          var t = document.createElement('div'); t.className = 'bwx-tog'; t.setAttribute('role', 'group');
          t.innerHTML = '<button type="button" data-m="eu">EU</button><button type="button" data-m="us">US</button>';
          bar.insertBefore(t, bar.firstChild);
          if (!ukTried) {
            ukTried = true;
            var pairs = spans.map(function (x) { var m = SZ_RE.exec(x.getAttribute('data-size')); return m ? [m[1].trim(), m[2].trim()] : null; }).filter(Boolean);
            loadUK(f, pairs, function () {
              try { var pref = localStorage.getItem('bwxSz'); if (pref === 'uk') szMode = 'uk'; } catch (e) {}
              paint(); document.dispatchEvent(new CustomEvent('bwx:size'));
            });
          }
        }
        if (UK && !f.querySelector('.bwx-tog [data-m="uk"]')) {
          var ub = document.createElement('button'); ub.type = 'button'; ub.setAttribute('data-m', 'uk'); ub.textContent = 'UK';
          f.querySelector('.bwx-tog').appendChild(ub);
        }
        f.querySelectorAll('.bwx-tog button').forEach(function (b) { b.classList.toggle('on', b.getAttribute('data-m') === szMode); });
      }
      var tsys = themeSys(f);
      var sel = f.querySelector('[data-bwx-szsel]'), r = f.querySelector('.m-variants__input:checked');
      if (sel && r) {
        var st = r.value;
        if (can) st = szText(r.value, true);
        else {
          var lb = f.querySelector('label[for="' + r.id + '"] .js-variant'), sys = tsys;
          if (lb && lb.textContent.trim()) st = (sys ? sys + ' ' : '') + lb.textContent.trim();
        }
        sel.classList.remove('is-idle'); if (sel.textContent !== st) { sel.textContent = st; document.dispatchEvent(new CustomEvent('bwx:size')); }
      }
    }
    document.addEventListener('click', function (e) {
      var tb = e.target.closest('.o-product__information .js-toggles-wrapper button');
      if (tb) { [].forEach.call(tb.parentNode.querySelectorAll('button'), function (x) { x.removeAttribute('data-bwx-act'); }); tb.setAttribute('data-bwx-act', '1'); }
      var b = e.target.closest('.bwx-tog button'); if (!b) return;
      e.preventDefault();
      szMode = b.getAttribute('data-m'); try { localStorage.setItem('bwxSz', szMode); } catch (x) {}
      paint(); document.dispatchEvent(new CustomEvent('bwx:size'));
    });
    document.addEventListener('change', function () { setTimeout(paint, 30); });
    document.addEventListener('click', function () { setTimeout(function () { paint(); document.dispatchEvent(new CustomEvent('bwx:size')); }, 120); });
    paint(); setInterval(paint, 700);
  }

  function stock() {
    var box = document.querySelector('[data-bwx-stock]'); if (!box) return;
    function j(a) { try { return JSON.parse(box.getAttribute(a) || '{}'); } catch (e) { return {}; } }
    var map = j('data-stock'), names = j('data-names'), online = j('data-online');
    var on = box.querySelector('[data-bwx-online]'), pick = box.querySelector('[data-bwx-pickup]');
    var txt = pick && pick.querySelector('[data-bwx-pickup-txt]');
    var single = box.getAttribute('data-single') === 'true';
    var last = null;
    function chosen() {
      var r = document.querySelector('.o-product__information .m-variants__input:checked');
      return !!r || single || !!new URLSearchParams(location.search).get('variant');
    }
    function current() {
      var f = document.querySelector('form[action*="/cart/add"] input[name="id"], form[action*="/cart/add"] select[name="id"]');
      return new URLSearchParams(location.search).get('variant') || (f && f.value) || box.getAttribute('data-selected') || '';
    }
    function render() {
      var id = current(), key = id + '|' + chosen(); if (key === last) return; last = key;
      var avail = online[id] === true;
      on.classList.toggle('is-low', !avail);
      on.querySelector('span').textContent = avail ? box.getAttribute('data-t-on') : box.getAttribute('data-t-off');
      if (!pick) return;
      if (!chosen() || !id) { txt.textContent = box.getAttribute('data-t-pick'); pick.classList.remove('is-low'); pick.classList.add('is-idle'); return; }
      pick.classList.remove('is-idle');
      var z = names[id] || '', s = map[id] || '';
      z = szText(String(z).split(' / ')[0]);
      var shown = document.querySelector('.o-product__information [data-bwx-szsel]');
      if (shown && !shown.classList.contains('is-idle') && shown.textContent.trim()) z = shown.textContent.trim();
      if (z === 'Default Title' || single) z = '';
      var k = z ? '' : '1';
      if (s) { txt.textContent = box.getAttribute('data-t-in' + k).replace('[z]', z).replace('[s]', s).replace('  ', ' '); pick.classList.remove('is-low'); }
      else { txt.textContent = box.getAttribute('data-t-none' + k).replace('[z]', z); pick.classList.add('is-low'); }
    }
    render();
    document.addEventListener('bwx:size', function () { last = null; render(); });
    document.addEventListener('change', function () { setTimeout(render, 60); });
    document.addEventListener('click', function () { setTimeout(render, 150); });
    setInterval(render, 800);
  }

  /* "complete the look" app block: place it under the add to cart button, as in the design */
  function upsell() {
    var info = document.querySelector('.o-product__information'); if (!info) return;
    var tries = 0;
    (function place() {
      var app = info.querySelector('.essential-upsell-product-addon-block');
      var anchor = info.querySelector('.wishlist-btn') || info.querySelector('.o-product__product-form');
      if (app && anchor && !app.__bwxMoved) { app.__bwxMoved = true; anchor.after(app); app.classList.add('bwx-upsell'); return; }
      if (++tries < 40) setTimeout(place, 250);
    })();
  }

  /* related products, loaded after the page */
  function recs() {
    var box = document.querySelector('[data-bwx-recs]'); if (!box) return;
    fetch(box.getAttribute('data-url')).then(function (r) { return r.text(); }).then(function (html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var g = doc.querySelector('[data-bwx-recs-grid]');
      if (!g || !g.children.length) return;
      box.querySelector('[data-bwx-recs-target]').innerHTML = g.innerHTML;
      box.hidden = false;
    }).catch(function () {});
  }

  /* rating next to the title */
  function rating() {
    var el = document.querySelector('[data-bwx-rating]'); if (!el) return;
    productReviews(el.getAttribute('data-skus'), 1).then(function (j) {
      var n = j && j.stats ? parseInt(j.stats.count, 10) : 0; if (!n) return;
      var avg = parseFloat(j.stats.average);
      el.querySelector('.bwx-stars__fill').style.width = (avg / 5 * 100) + '%';
      el.querySelector('.bwx-pdp-rating__txt').textContent = fmt(avg) + ' · ' + (n === 1 ? el.getAttribute('data-t-1') : el.getAttribute('data-t-n').replace('[n]', n));
      el.hidden = false;
    });
  }

  /* reviews section: only when the product has reviews */
  function reviews() {
    var box = document.querySelector('[data-bwx-reviews]'); if (!box) return;
    var skus = box.getAttribute('data-skus'), page = 1;
    var list = box.querySelector('[data-list]');
    function add(data) {
      (data || []).forEach(function (r) {
        var it = document.createElement('article'); it.className = 'bwx-rev__item';
        var name = dec(r.reviewer && r.reviewer.first_name) || '';
        var d = r.date_created ? new Date(r.date_created) : null;
        it.innerHTML = '<span class="bwx-stars" aria-label="' + r.rating + '/5"><span class="bwx-stars__fill" style="width:' + (r.rating / 5 * 100) + '%"></span></span>' +
          (r.title ? '<strong>' + esc(dec(r.title)) + '</strong>' : '') +
          '<p>' + esc(dec(r.review)) + '</p>' +
          '<span class="bwx-rev__by">' + esc(name) + (name ? ' · ' : '') + esc(box.getAttribute('data-t-verified')) + (d ? ' · ' + d.toLocaleDateString(document.documentElement.lang || undefined) : '') + '</span>';
        list.appendChild(it);
      });
    }
    productReviews(skus, 1).then(function (j) {
      var n = j && j.stats ? parseInt(j.stats.count, 10) : 0; if (!n) return;
      var avg = parseFloat(j.stats.average);
      box.querySelector('[data-avg]').textContent = fmt(avg);
      box.querySelector('[data-fill]').style.width = (avg / 5 * 100) + '%';
      box.querySelector('[data-n]').textContent = box.getAttribute('data-t-based').replace('[n]', n);
      add(j.reviews && j.reviews.data);
      var lastPage = j.reviews && j.reviews.last_page ? j.reviews.last_page : 1;
      if (lastPage > 1) {
        var b = document.createElement('button'); b.type = 'button'; b.className = 'bwx-rev__more'; b.textContent = box.getAttribute('data-t-more');
        b.addEventListener('click', function () {
          page++; productReviews(skus, page).then(function (k) { add(k && k.reviews && k.reviews.data); if (page >= lastPage) b.remove(); });
        });
        box.querySelector('.bwx-rev__list').after(b);
      }
      box.hidden = false;
    });
  }

  /* store rating in the trust strip */
  function storeRating() {
    var el = document.querySelector('[data-bwx-store-rating]'); if (!el) return;
    getJSON('https://api.reviews.io/merchant/latest?store=' + STORE).then(function (j) {
      if (!j || !j.stats) { el.remove(); return; }
      el.querySelector('[data-v]').textContent = fmt(j.stats.average_rating) + ' / 5';
      el.querySelector('[data-s]').textContent = el.getAttribute('data-t-sub').replace('[n]', Number(j.stats.total_reviews).toLocaleString());
    });
  }

  /* accordions: size guide proxy + links that open an accordion */
  function accordions() {
    var sg = document.querySelector('[data-bwx-acc-sg]'), trig = document.querySelector('[data-bwx-sg-open]');
    if (sg && trig) {
      sg.hidden = false;
      sg.addEventListener('click', function (e) { e.preventDefault(); trig.click(); });
    }
    document.addEventListener('click', function (e) {
      var a = e.target.closest('[data-bwx-open-acc]'); if (!a) return;
      var d = document.getElementById(a.getAttribute('data-bwx-open-acc')); if (!d) return;
      e.preventDefault(); d.open = true; d.scrollIntoView({ behavior: 'smooth', block: 'center' });
    });
  }

  function boot() { sizes(); stock(); upsell(); rating(); reviews(); storeRating(); accordions(); recs(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
